/** API `event_type` codes returned by the events service. */
export const EVENT_TYPE_CODE = {
  TOURNAMENT: 'T',
  /** Broadcast tournament (API code BT). */
  BROADCAST_TOURNAMENT: 'BT',
  LEAGUE: 'L',
  /** Broadcast league (API code BL). */
  BROADCAST_LEAGUE: 'BL',
} as const;

export type EventTypeCode =
  (typeof EVENT_TYPE_CODE)[keyof typeof EVENT_TYPE_CODE];

/** Tournament variants — leaderboard uses `is_tournament_leaderboard_available`. */
export const TOURNAMENT_EVENT_TYPE_CODES: ReadonlySet<string> = new Set([
  EVENT_TYPE_CODE.TOURNAMENT,
  EVENT_TYPE_CODE.BROADCAST_TOURNAMENT,
]);

/** League variants — leaderboard uses `is_league_leaderboard_available`. */
export const LEAGUE_EVENT_TYPE_CODES: ReadonlySet<string> = new Set([
  EVENT_TYPE_CODE.LEAGUE,
  EVENT_TYPE_CODE.BROADCAST_LEAGUE,
]);
